// 
// Sundae Lane Inc/Exc Tax Pricing integration with Bold Options
// - Calculates inc/exc tax pricing once bold options table has initialised
// 

if (!Shopify.formatMoney){
  Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);
  
    function defaultOption(opt, def) {
       return (typeof opt == 'undefined' ? def : opt);
    }
  
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');
  
      if (isNaN(number) || number == null) { return 0; }
  
      number = (number/100.0).toFixed(precision);
  
      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';
  
      return dollars + cents;
    }
  
    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
  
    return formatString.replace(placeholderRegex, value);
  };
}

window.theme = window.theme || {};

theme.ProductBoldOptions = (function() {

  function ProductBoldOptions(container) {
    this.container = container;

    if(!container){
      return;
    }

    this.parentContainer = document.querySelector('.price.product__price');
    this.priceContainer = document.querySelector('[data-price-container]');

    if(!this.priceContainer){
      return;
    }

    this.bindElements();
    this.bindEvents();

  }

  ProductBoldOptions.prototype = {

    bindElements: function(){
      const self = this;
      
      this.comparePriceElement = this.priceContainer.querySelector('.bold-pre-compare-price');
      this.newPriceElement = this.priceContainer.querySelector('.money.pre-money');

      this.variantInput = document.querySelector('.variant-selection');
    },

    bindEvents: async function(){
      const self = this;
      
      self.onPageLoad();

      this.variantInput.addEventListener('variant-change',function(event){
        // delay for bold to update
        setTimeout(function(){
          if (self.comparePriceElement && self.comparePriceElement.innerText.trim() !== '') {
            let element = document.querySelector('.price-original-per-variant[data-variant-id="'+event.detail.variant.id+'"]');
            self.updatePriceWithTax(element, 'sl-compare-price-item');
          }
          if (self.newPriceElement && self.newPriceElement.innerText.trim() !== '') {
            self.updatePriceWithTax(self.newPriceElement, 'sl-new-price-item');
          }
        },100);
        
      });
    },

    onPageLoad: async function(){
      const self = this;

      if (this.comparePriceElement && this.comparePriceElement.innerText.trim() !== '') {
        let element = document.querySelector('.price-original-per-variant.selected-on-load');
        this.updatePriceWithTax(element, 'sl-compare-price-item');
      }
      if (this.newPriceElement && this.newPriceElement.innerText.trim() !== '') {
        this.updatePriceWithTax(this.newPriceElement, 'sl-new-price-item');
      }

    },


    updatePriceWithTax: function(element,className){
      const self = this;
      
      let newPriceString = '';
      if (element){
        newPriceString = element.innerText.trim();
      }

      let includingTax = newPriceString;
      let price = self.convertDollarsToCents(includingTax);
      let excludingTax = self.calculateExcludingTax(price);

      let pastElement = document.querySelector('.'+className);
      if (pastElement){
        pastElement.remove();
      }

      let newElement = document.createElement('div');
      newElement.classList.add('price__current', className);
      
      let customerHasTag = false;
      if (window.Sundaelane.customer && window.Sundaelane.customer.customerTags) {
        let checkTagsArray = window.Sundaelane.settings.checkTags.split(',').map(tag => tag.trim().toLowerCase());    
        customerHasTag = window.Sundaelane.customer.customerTags.some(customerTag => 
          checkTagsArray.includes(customerTag.toLowerCase())
        );
      }
      if (customerHasTag) {
        newElement.innerHTML = `
        <span class="" data-excluding-tax="true"><span class="sl-price">${Shopify.formatMoney(excludingTax,window.Sundaelane.money_format)}</span><span class="sl-price-suffix"> excl. GST</span></span>
        `
      } else {
        newElement.innerHTML = `
        <span class="" data-including-tax="true"><span class="sl-price">${Shopify.formatMoney(price,window.Sundaelane.money_format)}</span><span class="sl-price-suffix"> incl. GST</span></span>
        `
      }

      this.priceContainer.classList.add('hidden');
      this.parentContainer.append(newElement);
    },

    convertDollarsToCents: function(dollarString) {
      let dollarAmount = parseFloat(dollarString.replace('$', '').replace(',', ''));
      let cents = Math.round(dollarAmount * 100);
      return cents;
    },

    calculateExcludingTax: function(amount){
      let gstDivider = 1 + (window.Sundaelane.settings.tax / 100);
      let excludingTax = amount / gstDivider;
      return excludingTax;
    }

  }

  return ProductBoldOptions;

})();


theme.CartBoldOptions = (function() {

  function CartBoldOptions(container) {
    this.container = container;

    if(!container){
      return;
    }


    this.bindElements();
    this.bindEvents();

  }

  CartBoldOptions.prototype = {

    bindElements: function(){
      const self = this;

      this.parentContainer = document.querySelector('.cart-subtotal');
      this.priceContainer = document.querySelector('[data-subtotal-container]');
      
      this.cartSubtotalElement = this.priceContainer.querySelector('[data-cart-total]');
      this.cartTitleSubtotalElement = document.querySelector('[data-cart-total]');
      this.titlePriceContainer = document.querySelector('[data-title-cart-subtotal]');
      this.titleParentContainer = document.querySelector('[data-cart-title-total]');
      
      this.cartLineItems = document.querySelectorAll('.cart-item');
    },

    bindEvents: async function(){
      const self = this;
      
      self.onPageLoad();

      window.addEventListener('cartcount:update', function(e) {
        self.cartSubtotalElement = self.priceContainer.querySelector('[data-cart-total]');
        self.cartTitleSubtotalElement = document.querySelector('[data-cart-total]');

        self.awaitBoldUpdateSubtotal();
        self.awaitBoldUpdateTitleSubtotal();
      });

    },

    awaitBoldUpdateSubtotal: function(){
      const self = this;
      let checkCount = 0;
      let maxChecks = 25;
    
      let checkInterval = setInterval(() => {
        checkCount++;
    
        if (self.priceHasChanged(self.cartSubtotalElement.innerText,self.subtotalPrice)) {
          try {
            self.updatePriceWithTax(self.cartSubtotalElement, 'sl-new-price-item');

          }
          catch(error) {
            console.log(error);
          }
          clearInterval(checkInterval); 
        } else if (checkCount >= maxChecks) {
          clearInterval(checkInterval);
        }
      }, 150); 
    },

    awaitBoldUpdateTitleSubtotal: function() {
      const self = this;
      let checkCountTitle = 0;
      let maxChecksTitle = 100;
    
      let checkIntervalTitle = setInterval(() => {
        checkCountTitle++;
    
        if (self.priceHasChanged(self.cartTitleSubtotalElement.innerText,self.subtotalTitlePrice)) {
          try {
            self.updatePriceTitleWithTax(self.cartTitleSubtotalElement, 'sl-new-price-item');
            self.updateLineItemTotals();
            self.updateLineItemSubtotals();
          }
          catch(error) {
            console.log(error);
          }
          clearInterval(checkIntervalTitle); 
        } else if (checkCountTitle >= maxChecksTitle) {
          clearInterval(checkIntervalTitle);
        }
      }, 100); 
    },

    updateLineItemTotals: function() {
      const self = this;
      self.cartLineItems.forEach((lineItem) => {
        let totalElement = lineItem.querySelector('[data-cartitem-total]');

        let comparePriceElement = totalElement.querySelector('.bold-pre-compare-price');
        let newPriceElement = totalElement.querySelector('.money.pre-money');

        if (comparePriceElement && comparePriceElement.innerText.trim() !== '') {
          self.updateItemTotalWithTax(totalElement,comparePriceElement, 'sl-compare-price-item');
        }
        if (newPriceElement && newPriceElement.innerText.trim() !== '') {
          self.updateItemTotalWithTax(totalElement,newPriceElement, 'sl-new-price-item');
        }
      });
    },

    updateLineItemSubtotals: function(){
      const self = this;

      self.cartLineItems.forEach((cartItem)=>{

        // if (cartItem.querySelector('.sl-price')){
        //   // already has gst value
        //   return;
        // }

        let productPriceElement = cartItem.querySelector('.cart-item--content-price');
        let comparePriceElement = productPriceElement.querySelector('.bold-pre-compare-price');
        let newPriceElement = productPriceElement.querySelector('.money.pre-money');
  
        if (comparePriceElement && comparePriceElement.innerText.trim() !== '') {
          self.updateItemPriceWithTax(productPriceElement,comparePriceElement, 'sl-compare-price-item');
        }
        if (newPriceElement && newPriceElement.innerText.trim() !== '') {
          self.updateItemPriceWithTax(productPriceElement,newPriceElement, 'sl-new-price-item');
        }
      });
    },

    onPageLoad: async function(){
      const self = this;

      if (this.cartSubtotalElement && this.cartSubtotalElement.innerText.trim() !== '') {
        this.updatePriceWithTax(this.cartSubtotalElement, 'sl-new-price-item');
      }

      if (this.cartTitleSubtotalElement && this.cartTitleSubtotalElement.innerText.trim() !== '') {
        this.updatePriceTitleWithTax(this.cartTitleSubtotalElement, 'sl-new-price-item');
      }

      // only runs on page load
      self.updateLineItemSubtotals();

      // will also update on quantity change
      self.updateLineItemTotals();
    },

    updateItemTotalWithTax: function(parent,element,className){
      const self = this;
      
      let includingTax = element.innerText;
      let price = self.convertDollarsToCents(includingTax);
      let excludingTax = self.calculateExcludingTax(price);

      let newElement = document.createElement('div');
      newElement.classList.add('price__current', className);
      
      let customerHasTag = false;
      if (window.Sundaelane.customer && window.Sundaelane.customer.customerTags) {
        let checkTagsArray = window.Sundaelane.settings.checkTags.split(',').map(tag => tag.trim().toLowerCase());    
        customerHasTag = window.Sundaelane.customer.customerTags.some(customerTag => 
          checkTagsArray.includes(customerTag.toLowerCase())
        );
      }
      if (customerHasTag) {
        newElement.innerHTML = `
        <span class="" data-excluding-tax="true"><span class="sl-price money">${Shopify.formatMoney(excludingTax,window.Sundaelane.money_format)}</span><span class="sl-price-suffix money"> ${window.Sundaelane.languages.excTaxSuffix}</span></span>
        `
      } else {
        newElement.innerHTML = `
        <span class="" data-including-tax="true"><span class="sl-price money">${Shopify.formatMoney(price,window.Sundaelane.money_format)}</span><span class="sl-price-suffix money"> ${window.Sundaelane.languages.incTaxSuffix}</span></span>
        `
      }

      // clear old values
      let oldValues = parent.querySelectorAll(className);
      oldValues.forEach(function(item){
        item.remove();
      });
              
      parent.querySelector('.money-details').classList.add('hidden');
      parent.querySelector('.money.pre-money').classList.add('hidden');
      parent.append(newElement);
    },
    
    updateItemPriceWithTax: function(parent,element,className){
      const self = this;
      
      let includingTax = element.innerText;
      let price = self.convertDollarsToCents(includingTax);
      let excludingTax = self.calculateExcludingTax(price);

      let newElement = document.createElement('div');
      newElement.classList.add('price__current', className);
      
      let customerHasTag = false;
      if (window.Sundaelane.customer && window.Sundaelane.customer.customerTags) {
        let checkTagsArray = window.Sundaelane.settings.checkTags.split(',').map(tag => tag.trim().toLowerCase());    
        customerHasTag = window.Sundaelane.customer.customerTags.some(customerTag => 
          checkTagsArray.includes(customerTag.toLowerCase())
        );
      }
      if (customerHasTag) {
        newElement.innerHTML = `
        <span class="" data-excluding-tax="true"><span class="sl-price money">${Shopify.formatMoney(excludingTax,window.Sundaelane.money_format)}</span><span class="sl-price-suffix money"> ${window.Sundaelane.languages.excTaxSuffix}</span></span>
        `
      } else {
        newElement.innerHTML = `
        <span class="" data-including-tax="true"><span class="sl-price money">${Shopify.formatMoney(price,window.Sundaelane.money_format)}</span><span class="sl-price-suffix money"> ${window.Sundaelane.languages.incTaxSuffix}</span></span>
        `
      }

      let oldValues = parent.querySelectorAll(className);
      oldValues.forEach(function(item){
        item.remove();
      });

      parent.querySelector('.money-details').classList.add('hidden');
      parent.querySelector('.money.pre-money').classList.add('hidden');
      parent.append(newElement);
    },

    priceHasChanged: function(newValue,oldValue){
      if (newValue && oldValue){
        if (newValue != oldValue){
          return true;
        }
      }

      return false;
    },

    lineItemsHaveChanged: function(newPrices, oldPrices) {
      const self = this;
      for (let i = 0; i < newPrices.length; i++) {
        if (self.priceHasChanged(newPrices[i], oldPrices[i])) {
          return true;
        }
      }
      return false;
    },

    getLineItemPrices: function() {
      const self = this;
      return Array.from(self.cartLineItems).map(lineItem => {
        let priceElement = lineItem.querySelector('[data-line-item-total]'); // Replace with your price element selector
        return priceElement ? priceElement.innerText.trim() : null;
      });
    },
    

    updatePriceWithTax: function(element,className){
      const self = this;
      
      self.subtotalPrice = element.innerText;
      
      let includingTax = element.innerText;
      let price = self.convertDollarsToCents(includingTax);
      let excludingTax = self.calculateExcludingTax(price);

      let newElement = document.createElement('div');
      newElement.classList.add('price__current', className);
      
      let customerHasTag = false;
      if (window.Sundaelane.customer && window.Sundaelane.customer.customerTags) {
        let checkTagsArray = window.Sundaelane.settings.checkTags.split(',').map(tag => tag.trim().toLowerCase());    
        customerHasTag = window.Sundaelane.customer.customerTags.some(customerTag => 
          checkTagsArray.includes(customerTag.toLowerCase())
        );
      }
      if (customerHasTag) {
        newElement.innerHTML = `
        <span class="" data-excluding-tax="true"><span class="sl-price money">${Shopify.formatMoney(excludingTax,window.Sundaelane.money_format)}</span><span class="sl-price-suffix money"> ${window.Sundaelane.languages.excTaxSuffix}</span></span>
        `
      } else {
        newElement.innerHTML = `
        <span class="" data-including-tax="true"><span class="sl-price money">${Shopify.formatMoney(price,window.Sundaelane.money_format)}</span><span class="sl-price-suffix money"> ${window.Sundaelane.languages.incTaxSuffix}</span></span>
        `
      }

      let oldValues = self.parentContainer.querySelectorAll('.sl-new-price-item');
      oldValues.forEach(function(item){
        item.remove();
      });

      self.priceContainer.classList.add('hidden');
      self.parentContainer.append(newElement);
    },


    updatePriceTitleWithTax: function(element,className){
      const self = this;
      
      self.subtotalTitlePrice = element.innerText;
      
      priceContainer = document.querySelector('[data-title-cart-subtotal]');
      parentContainer = document.querySelector('[data-cart-title-total]');

      let includingTax = element.innerText;
      let price = self.convertDollarsToCents(includingTax);
      let excludingTax = self.calculateExcludingTax(price);

      let newElement = document.createElement('div');
      newElement.classList.add('price__current', className);
      
      let customerHasTag = false;
      if (window.Sundaelane.customer && window.Sundaelane.customer.customerTags) {
        let checkTagsArray = window.Sundaelane.settings.checkTags.split(',').map(tag => tag.trim().toLowerCase());    
        customerHasTag = window.Sundaelane.customer.customerTags.some(customerTag => 
          checkTagsArray.includes(customerTag.toLowerCase())
        );
      }
      if (customerHasTag) {
        newElement.innerHTML = `
        <span class="sl-cart-title-subtotal" data-excluding-tax="true"><span class="sl-price">${Shopify.formatMoney(excludingTax,window.Sundaelane.money_format)}</span><span class="sl-price-suffix"> ${window.Sundaelane.languages.excTaxSuffix}</span></span>
        `
      } else {
        newElement.innerHTML = `
        <span class="sl-cart-title-subtotal" data-including-tax="true"><span class="sl-price">${Shopify.formatMoney(price,window.Sundaelane.money_format)}</span><span class="sl-price-suffix"> ${window.Sundaelane.languages.incTaxSuffix}</span></span>
        `
      }

      let oldValues = parentContainer.querySelectorAll('.sl-new-price-item');
      oldValues.forEach(function(item){
        item.remove();
      });

      priceContainer.classList.add('hidden');
      parentContainer.append(newElement);
    },

    convertDollarsToCents: function(dollarString) {
      let dollarAmount = parseFloat(dollarString.replace('$', '').replace(',', ''));
      let cents = Math.round(dollarAmount * 100);
      return cents;
    },

    calculateExcludingTax: function(amount){
      let gstDivider = 1 + (window.Sundaelane.settings.tax / 100);
      let excludingTax = amount / gstDivider;
      return excludingTax;
    }

  }

  return CartBoldOptions;

})();



theme.GridBoldOptions = (function() {

  function GridBoldOptions(container) {

    this.bindElements();
    this.bindEvents();

  }

  GridBoldOptions.prototype = {

    bindElements: function(){
      const self = this;
      this.productGridItems = document.querySelectorAll('.productitem');
      this.recommendedProductsContainer = document.querySelector('.product-recommendations--container');
      this.recentlyViewedContainer = document.querySelector('.product-recently-viewed--section');
    },

    bindEvents: async function(){
      const self = this;
      
      self.onPageLoad();

    },

    onPageLoad: async function(){
      const self = this;

      this.productGridItems.forEach((gridItem)=>{
        self.updateGridItemPrices(gridItem);
      });

      self.checkAsyncProducts(self.recommendedProductsContainer,'.productitem');
      self.checkAsyncProducts(self.recentlyViewedContainer,'.productitem');

    },

    updateGridItemPrices: function(gridItem){
      const self = this;
      
      let productPriceElement = gridItem.querySelector('.productitem--info');
      let comparePriceElement = productPriceElement.querySelector('.bold-pre-compare-price');
      let newPriceElement = productPriceElement.querySelector('.money.pre-money');
      if (productPriceElement.querySelector('.sl-price')){
        // already has gst values
        return;
      }
      if (comparePriceElement && comparePriceElement.innerText.trim() !== '') {
        self.updatePriceWithTax(productPriceElement,comparePriceElement, 'sl-compare-price-item');
      }
      if (newPriceElement && newPriceElement.innerText.trim() !== '') {
        self.updatePriceWithTax(productPriceElement,newPriceElement, 'sl-new-price-item');
      }
    },

    checkAsyncProducts: function(container,className){
      const self = this;

      if (container){
        let checkCount = 0;
        let maxChecks = 100;

        let checkInterval = setTimeout(()=>{
          checkCount++;
          if (itemsLoaded()){
            container.querySelectorAll(className).forEach((gridItem)=>{
              self.updateGridItemPrices(gridItem);
            });
            clearInterval(checkInterval);
          }
          else if (checkCount >= maxChecks) {
            clearInterval(checkInterval);
          }
        },100)

        function itemsLoaded(){
          const productGridItems = container.querySelectorAll(className);
          if (productGridItems.length > 0){
            return true;
          }
          return false;
        }
      }
    },

    updatePriceWithTax: function(parent,element,className){
      const self = this;
      
      let includingTax = element.innerText;
      let price = self.convertDollarsToCents(includingTax);
      let excludingTax = self.calculateExcludingTax(price);

      let newElement = document.createElement('div');
      newElement.classList.add('price__current', className);
      
      let customerHasTag = false;
      if (window.Sundaelane.customer && window.Sundaelane.customer.customerTags) {
        let checkTagsArray = window.Sundaelane.settings.checkTags.split(',').map(tag => tag.trim().toLowerCase());    
        customerHasTag = window.Sundaelane.customer.customerTags.some(customerTag => 
          checkTagsArray.includes(customerTag.toLowerCase())
        );
      }
      if (customerHasTag) {
        newElement.innerHTML = `
        <span class="" data-excluding-tax="true"><span class="sl-price money">${Shopify.formatMoney(excludingTax,window.Sundaelane.money_format)}</span><span class="sl-price-suffix money"> ${window.Sundaelane.languages.excTaxSuffix}</span></span>
        `
      } else {
        newElement.innerHTML = `
        <span class="" data-including-tax="true"><span class="sl-price money">${Shopify.formatMoney(price,window.Sundaelane.money_format)}</span><span class="sl-price-suffix money"> ${window.Sundaelane.languages.incTaxSuffix}</span></span>
        `
      }
      
              
      parent.querySelector('.money-details').classList.add('hidden');
      parent.querySelector('.money.pre-money').classList.add('hidden');
      parent.querySelector('[data-gst-price]').append(newElement);
    },

    convertDollarsToCents: function(dollarString) {
      let dollarAmount = parseFloat(dollarString.replace('$', '').replace(',', ''));
      let cents = Math.round(dollarAmount * 100);
      return cents;
    },

    calculateExcludingTax: function(amount){
      let gstDivider = 1 + (window.Sundaelane.settings.tax / 100);
      let excludingTax = amount / gstDivider;
      return excludingTax;
    }

  }

  return GridBoldOptions;

})();

document.addEventListener('DOMContentLoaded', function() {
  const cartContainer = document.querySelector(window.Sundaelane.cartContainerClass);
  const productContainer = document.querySelector(window.Sundaelane.productContainerClass);

  if (productContainer){
    let variantPriceToMatch = '';
    const selectedVariantPrice = document.querySelector('.price-original-per-variant.selected-on-load');
    if (selectedVariantPrice){
      variantPriceToMatch = selectedVariantPrice.innerText.trim();
    }

    boldOptionsCallbackProductPage(variantPriceToMatch);
  }
  else {
    boldOptionsCallback();
  }
  

  function boldOptionsCallback(){
    let checkCount = 0;
    let maxChecks = 25;
  
    let checkInterval = setInterval(() => {
      checkCount++;
  
      if (boldIsLoaded()) {
        try {
          new theme.CartBoldOptions(cartContainer);
        }
        catch(error) {
          console.log(error);
        }

        try {
          new theme.GridBoldOptions();
        }
        catch(error) {
          console.log(error);
        }
        
        clearInterval(checkInterval); 
      } else if (checkCount >= maxChecks) {
        clearInterval(checkInterval);
      }
    }, 150); 

    function boldIsLoaded(){
      const boldContainer = document.querySelector(window.Sundaelane.boldClass);
      if (!boldContainer){
        return false;
      }
      return true;
    }
  }

  function boldOptionsCallbackProductPage(variantPriceToMatch){
    let checkCount = 0;
    let maxChecks = 25;
  
    let checkInterval = setInterval(() => {
      checkCount++;
  
      if (boldIsLoadedProductPage(variantPriceToMatch)) {
        try {
          new theme.ProductBoldOptions(productContainer);
        }
        catch(error) {
          console.log(error);
        }

        try {
          new theme.GridBoldOptions();
        }
        catch(error) {
          console.log(error);
        }
        
        clearInterval(checkInterval); 
      } else if (checkCount >= maxChecks) {
        clearInterval(checkInterval);
      }
    }, 150); 

    function boldIsLoadedProductPage(variantPriceToMatch){
      const boldContainer = document.querySelector('.bold-pre-compare-price');
      // check the right variant is selected with bold before initialising for the product page
      if (boldContainer){
       if (boldContainer.innerText.trim() == variantPriceToMatch){
        return true;
       } 
      }

      return false
    }
  }
  
});
